import { render, staticRenderFns } from "./roles.template.vue?vue&type=template&id=a384949c&scoped=true&"
var script = {}
import style0 from "./roles.template.vue?vue&type=style&index=0&id=a384949c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a384949c",
  null
  
)

export default component.exports